export const MENU_ITEM_SELECTOR =
  '[role="menuitem"]:not([tabindex^="-"]), [role="menuitemradio"]:not([tabindex^="-"])';

/** The focusable items that belong to `menu` itself, skipping those inside a nested submenu. */
export const getOwnMenuItems = (menu: HTMLElement): HTMLElement[] =>
  Array.from(menu.querySelectorAll<HTMLElement>(MENU_ITEM_SELECTOR)).filter(
    (item) => item.parentElement?.closest('[role="menu"]') === menu
  );

/** Moves focus among `menu`'s own items, wrapping at either end. */
export const focusMenuItem = (menu: HTMLElement, target: 'first' | 'next' | 'previous') => {
  const items = getOwnMenuItems(menu);
  if (items.length === 0) return;

  const currentIndex = items.findIndex((item) => item === document.activeElement);
  let index = 0;
  if (target === 'next') index = (currentIndex + 1) % items.length;
  if (target === 'previous') index = currentIndex <= 0 ? items.length - 1 : currentIndex - 1;

  items[index]?.focus();
};
